exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.centerize[data-v-7dcbeca3] {\n    margin: 30vh auto;\n}\n.divToCenter[data-v-7dcbeca3] {\n    margin: 1rem auto;\n}\n\n\n", ""]);

// exports
